export default "__VITE_ASSET__BzMwXfZ9__"